import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
var EditorInputDialog = function (_a) {
    var title = _a.title, isOpen = _a.isOpen, onClose = _a.onClose, onConfirm = _a.onConfirm, children = _a.children;
    var handleClose = function () {
        onClose && onClose();
    };
    var handleConfirm = function (e) {
        e.preventDefault();
        if (onConfirm) {
            onConfirm();
            handleClose();
        }
    };
    return (React.createElement(Dialog, { open: isOpen, onClose: handleClose, "aria-labelledby": "form-dialog-title", maxWidth: "xs" },
        React.createElement(DialogTitle, { id: "form-dialog-title" }, title),
        React.createElement(DialogContent, { style: { width: '350px ' } }, children),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleClose, color: "secondary" }, "Cancel"),
            React.createElement(Button, { onClick: handleConfirm, color: "primary", disabled: !onConfirm }, "Confirm"))));
};
export default EditorInputDialog;
//# sourceMappingURL=EditorInputDialog.js.map